import React from "react";
import { Chip } from "@mui/material";

export type FreshnessTier = "fresh" | "aging" | "stale";
export type FreshnessBadgeColor = "green" | "yellow" | "red";

interface FreshnessBadgeProps {
  tier: FreshnessTier;
  note?: string | null;
  badge?: FreshnessBadgeColor | null;
}

const labelFor = (tier: FreshnessTier, note?: string | null): string => {
  if (tier === "fresh") return "Fresh";
  if (tier === "aging") return `Aging - ${note || "verify date"}`;
  return "Verify with property";
};

const FreshnessBadge: React.FC<FreshnessBadgeProps> = ({ tier, note, badge }) => {
  const resolvedBadge = badge || (
    tier === "fresh" ? "green" : tier === "aging" ? "yellow" : "red"
  );
  return (
    <Chip
      data-freshness-tier={tier}
      data-freshness-badge={resolvedBadge}
      size="small"
      color={resolvedBadge === "green" ? "success" : resolvedBadge === "yellow" ? "warning" : "error"}
      label={labelFor(tier, note)}
      sx={{ fontWeight: 700, borderRadius: 1.5, height: 26 }}
    />
  );
};

export default FreshnessBadge;
